module.exports = __webpack_public_path__ + "assets/11ce44cf89fad3da359c6afbb0722b9c.mp3";